var render, staticRenderFns
import script from "./Rich.vue?vue&type=script&lang=js&"
export * from "./Rich.vue?vue&type=script&lang=js&"
import style0 from "./Rich.vue?vue&type=style&index=0&id=5015507b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015507b",
  null
  
)

export default component.exports